import * as React from "react";
import type { SVGProps } from "react";
const SvgScissors = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.707 4.707a1 1 0 0 0-1.414-1.414zM7.413 15.173a1 1 0 1 0 1.414 1.414zm7.764-1.4a1 1 0 0 0-1.413 1.415zm4.117 6.935a1 1 0 0 0 1.412-1.416zM8.827 7.413a1 1 0 0 0-1.414 1.414zm2.466 5.294a1 1 0 0 0 1.414-1.414zM8 6a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zM6 8a2 2 0 0 1-2-2H2a4 4 0 0 0 4 4zM4 6a2 2 0 0 1 2-2V2a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zm2 14a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2H2a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2v-2a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zM19.293 3.293l-11.88 11.88 1.414 1.414 11.88-11.88zm-5.53 11.895 5.53 5.52 1.413-1.416-5.53-5.52zm-6.35-6.36 3.88 3.88 1.414-1.415-3.88-3.88z"
    />
  </svg>
);
export default SvgScissors;
